import { fetchQuery, graphql } from 'react-relay';
import { relayEnv } from '../relay/relay-env';
import type { spSiteContextQuery } from './__generated__/spSiteContextQuery.graphql';

class SiteContext {
    private siteObj: ISiteContext | undefined;
    private inFlight: Promise<ISiteContext | undefined> | undefined;

    get = async (siteUrl: string): Promise<ISiteContext | undefined> => {
        if (!siteUrl) return undefined;
        if (this.siteObj) return this.siteObj;
        if (this.inFlight) return this.inFlight;

        this.inFlight = fetchQuery<spSiteContextQuery>(
            relayEnv,
            query,
            { siteUrl },
            { fetchPolicy: 'store-or-network' }
        )
            .toPromise()
            .then((result) => {
                this.siteObj = result?.getSharePointSite as unknown as ISiteContext | undefined;
                return this.siteObj;
            })
            .catch(() => {
                this.siteObj = undefined;
                return undefined;
            })
            .finally(() => {
                this.inFlight = undefined;
            });

        return this.inFlight;
    };
}

const query = graphql`
    query spSiteContextQuery($siteUrl: String!) {
        getSharePointSite(siteUrl: $siteUrl) {
            siteUrl
            siteId
            name: title
            # webId
        }
    }
`;

export const spSiteContext = new SiteContext();
